import { memo } from "react";
function EquipmentDefectsIcon({ color = "#808080" }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8001 13.9991L8.61675 9.81576L9.56675 8.86576L13.7501 13.0491L12.8001 13.9991ZM3.11675 13.9991L2.16675 13.0491L7.00008 8.21576L5.21675 6.43242L4.83341 6.81576L4.10008 6.08242V7.49909L3.70008 7.89909L1.66675 5.86576L2.06675 5.46576H3.50008L2.70008 4.66576L4.88341 2.48242C5.0723 2.29353 5.27786 2.16576 5.50008 2.09909C5.7223 2.03242 5.96675 1.99909 6.23341 1.99909C6.50008 1.99909 6.74453 2.04631 6.96675 2.14076C7.18897 2.2352 7.39453 2.37687 7.58341 2.56576L5.80008 4.34909L6.60008 5.14909L6.20008 5.54909L7.93341 7.28242L9.96675 5.24909C9.87786 5.10464 9.80841 4.93798 9.75841 4.74909C9.70841 4.5602 9.68341 4.3602 9.68341 4.14909C9.68341 3.5602 9.8973 3.05187 10.3251 2.62409C10.7529 2.19631 11.2612 1.98242 11.8501 1.98242C12.0167 1.98242 12.1584 1.99909 12.2751 2.03242C12.3917 2.06576 12.489 2.1102 12.5667 2.16576L11.1501 3.58242L12.4001 4.83242L13.8167 3.41576C13.8723 3.50464 13.9195 3.61298 13.9584 3.74076C13.9973 3.86853 14.0167 4.01576 14.0167 4.18242C14.0167 4.77131 13.8029 5.27964 13.3751 5.70742C12.9473 6.1352 12.439 6.34909 11.8501 6.34909C11.6501 6.34909 11.4779 6.3352 11.3334 6.30742C11.189 6.27964 11.0556 6.23798 10.9334 6.18242L3.11675 13.9991Z"
        stroke={color}
        strokeWidth="1.1"
      />
    </svg>
  );
}

export default memo(EquipmentDefectsIcon);
